import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useHttp from "../../hooks/use-http";

const CardFailed = () => {
  const [transactionDetails, setTransactionDetails] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [time, setTime] = useState(30);
  const { sendRequest: getTransaction } = useHttp();
  const { sendRequest: getTransactionStatus } = useHttp();

  const { id } = useParams();

  const fetchTransactionInfo = (data) => {
    setTransactionDetails(data);
  };

  const fetchTransaction = useCallback(() => {
    getTransaction(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/${id}`,
        headers: { "Content-Type": "application/json" },
      },
      fetchTransactionInfo
    );
  }, [getTransaction, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchTransaction();
    };
    fetchData();
  }, [fetchTransaction]);

  const confirmStatus = useCallback((data) => {
    setStatusMessage(data?.data?.statusMessage);

    let interval = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          window.location.href = data?.data?.returnUrl;
          return 0;
        } else {
          return prevTime - 1;
        }
      });
    }, 1000);
  }, []);

  const fetchTransactionStatus = useCallback(() => {
    getTransactionStatus(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/status/${id}`,
        headers: { "Content-Type": "application/json" },
      },
      confirmStatus
    );
  }, [confirmStatus, getTransactionStatus, id]);

  useEffect(() => {
    const getStatus = async () => {
      await fetchTransactionStatus();
    };
    getStatus();
  }, [fetchTransactionStatus]);

  const currentCurrency = transactionDetails?.data?.currency || "NGN";
  const formattedCurrencySymbol = currentCurrency === "NGN" ? "₦" : currentCurrency;
  const shoppingCartAmount = transactionDetails?.data?.amount || 0;
  const processingFeeAmount = transactionDetails?.data?.fee || 0;
  const totalAmount = shoppingCartAmount + processingFeeAmount;

  return (
    <div className="w-full max-w-[560px] mx-auto py-4">
      {/* Amount details block */}
      <div className="flex justify-between border-b border-slate-100 pb-6 mb-6">
        <div>
          <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Merchant</p>
          <h4 className="text-sm font-extrabold text-slate-800 uppercase mt-0.5">
            {transactionDetails?.data?.merchantName || "Merchant"}
          </h4>
        </div>
        <div className="text-right">
          <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Total Amount</p>
          <h3 className="text-base font-bold text-slate-800 mt-1">
            {formattedCurrencySymbol}{totalAmount.toLocaleString()}
          </h3>
          <p className="text-xs text-slate-500 mt-0.5">
            {transactionDetails?.data?.email}
          </p>
        </div>
      </div>

      {/* Failure Status block */}
      <div className="text-center space-y-4 my-8">
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-red-50 border border-red-200 text-red-500 rounded-full flex items-center justify-center">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        </div>

        <div className="space-y-1 px-4">
          <h3 className="text-lg font-bold text-slate-800">
            Transaction Failed
          </h3>
          <p className="text-xs text-slate-500 leading-relaxed max-w-[380px] mx-auto">
            {statusMessage || "Payment of the amount has not been confirmed. Your transaction was not successful."}
          </p>
        </div>
      </div>

      {/* Action Redirect details */}
      <div className="pt-4 border-t border-slate-100 flex justify-center">
        <div className="w-full text-center py-3 bg-[#fffafb] border border-red-100 text-red-600 font-semibold text-xs rounded-lg">
          Redirecting in 00:{time.toString().padStart(2, "0")}s
        </div>
      </div>
    </div>
  );
};

export default CardFailed;
